<template>
  <aha-modal
    @hide="hide()"
    :title="title"
    action-position="justify-end"
  >
    <span class="block mb-3">{{ warningMessage }}:</span>
    <a
      class="modal-confirm-open-link"
      :href="url"
      target="_blank"
      :title="url"
    >{{ url }}</a>
    <template #action>
      <aha-antd-button variant="text" @click="hide()">
        <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
      </aha-antd-button>
    </template>
  </aha-modal>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return this.$i18nPresenter.t('Leaving the presentation')
    },
    warningMessage() {
      return this.$i18nPresenter.t('This link will take you to a page that is not part of the presentation')
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style lang="scss" scoped>
  .modal-confirm-open-link {
    &:hover{
      text-decoration: underline!important;
    }
    text-decoration: underline !important;
    pointer-events: inherit;
    color: #6A1EBB !important;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
